export default function (value) {
  var formatter = new Intl.NumberFormat('nl-BE', {
    style: 'currency',
    currency: 'EUR'
  })
  return formatter.format(value)
}
